/**
 * Lógica pura de convite/compartilhamento de evento.
 * Mantida sem dependência do Firestore para ser testável isoladamente.
 */

/** Normaliza um email digitado: apara espaços e caixa baixa. */
export function normalizeEmail(raw) {
  return String(raw ?? '').trim().toLowerCase();
}

/** Validação simples de formato de email. */
export function isValidEmail(email) {
  const e = normalizeEmail(email);
  if (!e) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
}

/**
 * Calcula como ficam os arrays de acesso ao convidar um usuário.
 * Não muta os arrays de entrada.
 *
 * @returns {{
 *   ok: boolean,
 *   reason?: 'invalid_target' | 'is_owner',
 *   invitedUserIds: string[],
 *   editorUserIds: string[],
 *   alreadyHadAccess: boolean,
 *   promotedToEditor: boolean
 * }}
 */
export function computeInviteUpdate({
  ownerId,
  targetUid,
  currentInvited = [],
  currentEditors = [],
  asEditor = false,
} = {}) {
  const invited = Array.isArray(currentInvited) ? currentInvited.slice() : [];
  const editors = Array.isArray(currentEditors) ? currentEditors.slice() : [];

  if (!targetUid) {
    return { ok: false, reason: 'invalid_target', invitedUserIds: invited, editorUserIds: editors, alreadyHadAccess: false, promotedToEditor: false };
  }
  if (targetUid === ownerId) {
    return { ok: false, reason: 'is_owner', invitedUserIds: invited, editorUserIds: editors, alreadyHadAccess: false, promotedToEditor: false };
  }

  const alreadyInvited = invited.includes(targetUid);
  const alreadyEditor = editors.includes(targetUid);

  const nextInvited = alreadyInvited ? invited : [...invited, targetUid];
  let nextEditors = editors;
  let promotedToEditor = false;
  if (asEditor && !alreadyEditor) {
    nextEditors = [...editors, targetUid];
    promotedToEditor = true;
  }

  return {
    ok: true,
    invitedUserIds: nextInvited,
    editorUserIds: nextEditors,
    alreadyHadAccess: alreadyInvited,
    promotedToEditor,
  };
}
